import React, { useEffect, useState } from 'react';
import { Text, TouchableOpacity, View } from '@applane/react-core-components';
import { invoke } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { getUserRole } from '../../../Lib/helpers';
import { ROUTES } from '../../../Lib/constants';
import vars from '../../../theme/vars';

const { headings } = vars;

const ViewButton = (props) => {
  const [h, setH] = useState(false);
  const { ruleData } = props;
  return (
    <TouchableOpacity>
      <View
        onClick={() => {
          props.navigation.push({
            view: ROUTES.makeModelList.name,
            params: {
              title: 'Makes And Models',
              item: ruleData,
              ruleId: ruleData?._id,
            },
          });
        }}
        onMouseOver={() => setH(true)}
        onMouseLeave={() => setH(false)}
        onFocus={() => setH(false)}
        style={{
          cursor: 'pointer',
          width: 110,
          borderRadius: 15,
          backgroundColor: h ? 'rgb(118,215,196)' : 'rgb(72,201,176)',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
      >
        <Text style={{ ...headings.h8, color: '#FFF' }}>View</Text>
      </View>
    </TouchableOpacity>
  );
};

const ViewRule = (props) => {
  const [data, setData] = useState({
    _id: '--',
    rulename: '--',
    minsaleperiod: '--',
    rulestatus: '--',
    madeByName: '--',
    madeBy: { _id: 1, bulkCalls: 1 },

    // percentages
    ruleSpread: 1,
    ruleEnhancement: 1,

    // mileage radio , min , max and range fields
    mileageType: 1,
    minMileage: 1,
    maxMileage: 1,

    // car details and year range
    carDetails: '--',
    fromYear: '--',
    toYear: '--',
  });

  const getData = async () => {
    const { result } = await invoke({
      id: 'getRuleData',
      paramValue: { ruleId: props?.navigation?.state?.params?.item?._id },
    });
    setData(result);
  };

  useEffect(() => {
    // console.log('view rule ue');
    getData();
  }, [props.lastViewIndex]);

  // console.log('rule gata view page...', data);

  const arr = [];
  arr.push({
    label: 'Rule Name',
    render: () => <Text style={{ fontSize: 20 }}>{data?.rulename}</Text>,
  });

  arr.push({
    label: 'Min Sale Period (Months)',
    render: () => <Text style={{ fontSize: 20 }}>{data?.minsaleperiod}</Text>,
  });

  arr.push({
    label: 'Mileage Range',
    render: () => (
      <Text style={{ fontSize: 20 }}>
        {data?.mileageType === 'All'
          ? 'All'
          : `${data?.minMileage}-${data?.maxMileage}`}
      </Text>
    ),
  });

  if (getUserRole() === 'superadmin' || getUserRole() === 'admin') {
    arr.push({
      label: 'Made By',
      render: () => <Text style={{ fontSize: 20 }}>{data?.madeByName}</Text>,
    });
  }

  arr.push({
    label: 'Status',
    render: () => <Text style={{ fontSize: 20 }}>{data?.rulestatus}</Text>,
  });

  arr.push({
    label: 'Enhancement',
    render: () => (
      <Text style={{ fontSize: 20 }}>{`${data?.ruleEnhancement} %`}</Text>
    ),
  });

  arr.push({
    label: 'Spread',
    render: () => (
      <Text style={{ fontSize: 20 }}>
        {data?.ruleSpread ? `${data?.ruleSpread} %` : '--'}
      </Text>
    ),
  });

  if (data?.carDetails !== 'Any') {
    arr.push({
      label: 'Year Range',
      render: () => (
        <Text
          style={{
            fontSize: 20,
          }}
        >
          {`${data?.fromYear} - ${data?.toYear}`}
        </Text>
      ),
    });
  } else {
    arr.push({
      label: 'Year Range',
      render: () => (
        <Text
          style={{
            fontSize: 20,
          }}
        >
          Any
        </Text>
      ),
    });
  }
  arr.push({
    label: 'Makes And Models',
    render: () => <ViewButton {...props} ruleData={data} />,
  });
  return (
    <Form
      type="standard"
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: arr,
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};

export default ViewRule;
